<template>
    <div class="popup-response success-popup popup-cb-ss popup-all" style="display: block" >
        <div class="popup-container">
            <div class="popup-vue has-header">
                <div class="popup-header">
                    <img class="popup-logo" src="/img/credit-landing-vue/popup-logo.svg">
                    <div class="popup-tel" v-html="__t('Телефон попап успеха')"></div>
                </div>
                <div class="popup-content-on-mob">
                    <div class="popup-img">
                        <img src="/img/credit-landing-vue/succes.svg" alt="succes">
                    </div>
                    <div class="popup-title" v-html="__t('Callback Вашу заявку прийнято в роботу')"></div>

                    <div class="popup-description" v-if="true">
                        <p v-html="__t('Callback Наш фахівець зв’яжеться з вами найближчим часом і відповість на всі запитання.')"></p>
                    </div>

                    <div class="button-wrapper page-bottom ">
                        <a id="closePopupFocusId" tabindex="0" class="single-button btn violet-btn" @click="popupClose()" @keydown.enter.prevent="popupClose()">{{__t('Закрити')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'popup-callback-success',
        props: [],
        data() {
            return {

            }
        },
        methods: {
            __t(phrase) {
                return window.__t(phrase);
            },

            popupClose: function() {
                this.$emit('popupCallbackSuccessHide')
            }
        }
    }

</script>